import avi from '../../assets/images/live-avi.png';
import Button from '../Button/Button';

const LiveClassCard = ({
  person,
  meetingUrl,
  title,
  subtitle,
  when,
  time,
  hostMeetingUrl,
  groupClass,
  startTime,
  schedules,
}) => {
  let values = JSON.parse(localStorage.getItem('userData'));

  const weekdays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  const d = new Date();
  let day = weekdays[d.getDay()];
  let hour = d.getHours();

  return (
    <div className='live-class-card'>
      <div className='live-class-card__left'>
        {/* <img src={avi} alt='' /> */}
        <div className='live-class-card__left__texts'>
          <p className='live-class-card__left__texts__title'>{title}</p>
          <p className='live-class-card__left__texts__subtitle'>
            {groupClass ? 'Group Class' : 'One-on-one Class'}
          </p>
          {schedules.map((el) => (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '32px',
              }}
            >
              <div
                className='live-class-card__left__texts__bottom'
                style={{ marginBottom: '16px' }}
              >
                <div className='live-class-card__left__texts__bottom__tag'>
                  <p>{el.day}s</p>
                </div>
                <p>{`${new Date(
                  '1970-01-01T' + el?.start_time + 'Z'
                ).toLocaleTimeString('en-US', {
                  timeZone: 'UTC',
                  hour12: true,
                  hour: 'numeric',
                  minute: 'numeric',
                })} - ${new Date(
                  '1970-01-01T' + el?.end_time + 'Z'
                ).toLocaleTimeString('en-US', {
                  timeZone: 'UTC',
                  hour12: true,
                  hour: 'numeric',
                  minute: 'numeric',
                })}`}</p>
              </div>

              <div className='live-class-card__right'>
                <Button
                  className={'primary-btn'}
                  text={!values?.school ? 'Join' : 'Start Class'}
                  disabled={
                    values?.is_admin
                      ? false
                      : day.toLowerCase() !== el.day?.toLowerCase() ||
                        hour < Number(el?.start_time.split(':')[0])
                  }
                  onClick={() => {
                    person === 'student'
                      ? window.open(meetingUrl, '_blank')
                      : window.open(hostMeetingUrl, '_blank');
                  }}
                />
                {/* <svg
          width='4'
          height='12'
          viewBox='0 0 4 12'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M2.00033 3.33335C2.73366 3.33335 3.33366 2.73335 3.33366 2.00002C3.33366 1.26669 2.73366 0.666687 2.00033 0.666687C1.26699 0.666687 0.666992 1.26669 0.666992 2.00002C0.666992 2.73335 1.26699 3.33335 2.00033 3.33335ZM2.00033 4.66669C1.26699 4.66669 0.666992 5.26669 0.666992 6.00002C0.666992 6.73335 1.26699 7.33335 2.00033 7.33335C2.73366 7.33335 3.33366 6.73335 3.33366 6.00002C3.33366 5.26669 2.73366 4.66669 2.00033 4.66669ZM2.00033 8.66669C1.26699 8.66669 0.666992 9.26669 0.666992 10C0.666992 10.7334 1.26699 11.3334 2.00033 11.3334C2.73366 11.3334 3.33366 10.7334 3.33366 10C3.33366 9.26669 2.73366 8.66669 2.00033 8.66669Z'
            fill='#5A5955'
          />
        </svg> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LiveClassCard;
